module.exports = __webpack_public_path__ + "static/media/white-burger.317f84a7.svg";